import React from 'react';
import PageRenderer from '../../components/common/PageRenderer';

const chairman = {
  name: 'Surv. Emmanuel Sunday Omuya',
  qualification: 'FNIS',
  role: 'Chairman',
  image: '/Surv Emmanuel.jpeg',
};

const executives = [
  {
    name: 'Surv. Olajide Isaac Arinola',
    qualification: 'MNIS',
    role: 'Vice Chairman',
    image: '/Surv Olaji.jpeg',
  },
  {
    name: 'Surv. Peter O. Adetula',
    qualification: 'MNIS',
    role: 'Secretary',
    image: '/Surv Peter O. Adetula mnis secretary Appsn fct.jpeg',
  },
  {
    name: 'Surv. Fasoyin A. Oladimeji',
    qualification: 'MNIS',
    role: 'Treasurer',
    image: '/Surv Fasoyin A. Oladimeji mnis treasurer.jpeg',
  },
  {
    name: 'Surv. John I. Ekele',
    qualification: 'MNIS',
    role: 'Public Relations Officer',
    image: '/Surv John I. Ekele mnis PRO appsn fct.jpeg',
  },
  {
    name: 'Surv. Adebayo Taiwo',
    qualification: 'MNIS',
    role: 'Auditor',
    image: '/Surv Adebayo Taiwo mnis auditor.jpeg',
  },
  {
    name: 'Surv. Solomon B. Olukotun',
    qualification: 'FNIS',
    role: 'Ex Officio I',
    image: '/Surv Solomon B. Olukotun fnis ex officio 1.jpeg',
  },
];

function ExecCard({ exec }) {
  return (
    <div className="group relative bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300">
      <div className="relative aspect-[4/5] overflow-hidden bg-gradient-to-br from-[#0B5D1E]/10 to-[#C8A951]/10">
        <img
          src={exec.image}
          alt={`${exec.name} - ${exec.role}`}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-0 left-0 h-1 w-0 bg-[#C8A951] group-hover:w-full transition-all duration-500" />
      </div>
      <div className="px-4 py-3 text-center">
        <span className="inline-block text-[10px] font-bold uppercase tracking-[0.2em] text-[#C8A951] mb-1">
          {exec.role}
        </span>
        <h3 className="text-[#111827] text-sm md:text-base font-bold leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
          {exec.name}
        </h3>
        <p className="text-xs text-gray-500 mt-0.5 tracking-wide">{exec.qualification}</p>
      </div>
    </div>
  );
}

function DefaultContent() {
  return (
    <>
      {/* Hero */}
      <section className="relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #0B5D1E 0%, #094A18 100%)' }}>
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 20% 20%, #C8A951 0%, transparent 40%), radial-gradient(circle at 80% 80%, #C8A951 0%, transparent 40%)' }} />
        <div className="relative max-w-6xl mx-auto px-4 py-20 md:py-24 text-center">
          <div className="inline-block text-[#C8A951] text-xs font-bold tracking-[0.3em] uppercase mb-3">
            APPSN FCT Branch
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Executive Council
          </h1>
          <div className="w-20 h-0.5 bg-[#C8A951] mx-auto mb-5" />
          <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
            Meet the elected officers leading the Association of Private Practising Surveyors of Nigeria, FCT Branch.
          </p>
        </div>
      </section>

      {/* Chairman — featured card */}
      <section className="relative py-12 md:py-16 bg-gradient-to-b from-[#F8FAFB] to-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-8">
            <div className="inline-block text-[#0B5D1E] text-xs font-bold tracking-[0.25em] uppercase mb-2">Branch Chairman</div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900" style={{ fontFamily: "'Playfair Display', serif" }}>
              Leadership
            </h2>
          </div>

          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100 grid md:grid-cols-5 gap-0">
            <div className="md:col-span-2 relative bg-gradient-to-br from-[#0B5D1E]/5 to-[#C8A951]/5 flex items-center justify-center p-4 md:p-6">
              {/* Smaller photo container; object-contain keeps the FULL photo visible (no cropping) */}
              <div className="w-full max-w-[220px] aspect-[3/4]">
                <img
                  src={chairman.image}
                  alt={`${chairman.name} - Chairman`}
                  className="w-full h-full object-contain object-center"
                />
              </div>
            </div>
            <div className="md:col-span-3 p-6 md:p-8 flex flex-col justify-center">
              <span className="inline-block text-[10px] font-bold uppercase tracking-[0.25em] text-[#C8A951] mb-2">
                Chairman
              </span>
              <h3 className="text-xl md:text-2xl font-bold text-[#0B5D1E] leading-tight mb-1.5" style={{ fontFamily: "'Playfair Display', serif" }}>
                {chairman.name}
              </h3>
              <p className="text-sm text-gray-500 font-semibold tracking-wide mb-4">{chairman.qualification}</p>
              <div className="w-12 h-0.5 bg-[#C8A951] mb-4" />
              <p className="text-gray-600 text-sm leading-relaxed">
                Surv. Emmanuel Sunday Omuya presides over the affairs of the branch, providing strategic leadership and representing APPSN FCT in all official engagements.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Other Executives */}
      <section className="py-14 md:py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-10">
            <div className="inline-block text-[#0B5D1E] text-xs font-bold tracking-[0.25em] uppercase mb-2">The Council</div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
              Executive Officers
            </h2>
            <p className="text-gray-500 max-w-xl mx-auto text-sm">
              Dedicated professionals elected to serve the branch and advance the surveying profession in the Federal Capital Territory.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
            {executives.map((exec) => (
              <ExecCard key={exec.name} exec={exec} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA strip */}
      <section className="bg-[#062E10] py-14">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-xl md:text-2xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Reach the APPSN FCT Branch Secretariat
          </h2>
          <p className="text-white/70 mb-6 text-sm md:text-base max-w-xl mx-auto">
            For administrative correspondence, partnership enquiries, or membership matters, please contact the secretariat.
          </p>
          <a href="/contact" className="inline-flex items-center gap-2 bg-[#C8A951] hover:bg-[#B89A42] text-[#062E10] px-7 py-3 rounded-lg text-sm font-bold tracking-wide transition shadow-lg">
            Contact Us
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
        </div>
      </section>
    </>
  );
}

export default function ExecutiveMembers() {
  return <PageRenderer pageKey="executive_members" fallback={<DefaultContent />} />;
}
